<script setup lang="ts">
    import InputError from '@/components/InputError.vue';
    import TextLink from '@/components/TextLink.vue';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import AuthLayout from '@/layouts/AuthLayout.vue';
    import { Head, useForm } from '@inertiajs/vue3';
    import { LoaderCircle } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    defineProps<{
        status?: string;
    }>();

    const form = useForm({
        email: '',
    });

    const submit = () => {
        form.post(route('password.email'));
    };
</script>

<template>
    <AuthLayout
        :title="t('auth.forgot_password')"
        :description="t('auth.enter_email_to_receive_password_reset_link')"
    >
        <Head :title="t('auth.forgot_password')" />

        <div
            v-if="status"
            class="text-accent mb-4 text-xs font-medium"
        >
            {{ status }}
        </div>

        <div class="space-y-6">
            <form
                @submit.prevent="submit"
                class="flex flex-col gap-4"
            >
                <div class="grid gap-2">
                    <Input
                        id="email"
                        type="email"
                        name="email"
                        autocomplete="off"
                        v-model="form.email"
                        autofocus
                        :placeholder="t('auth.email_placeholder')"
                        class="placeholder:text-foreground/80"
                    />
                    <InputError :message="form.errors.email" />
                </div>

                <Button
                    width="full"
                    :disabled="form.processing"
                    :loading="form.processing"
                >
                    {{ t('auth.email_password_reset_link') }}
                </Button>
            </form>

            <div class="text-muted-foreground space-x-1 text-center text-xs">
                <span>{{ t('auth.or_return_to') }}</span>
                <TextLink :href="route('login')">{{ t('auth.log_in') }}</TextLink>
            </div>
        </div>
    </AuthLayout>
</template>
